import { render, staticRenderFns } from "./LineTable.vue?vue&type=template&id=2f825fa0&scoped=true"
import script from "./LineTable.vue?vue&type=script&lang=js"
export * from "./LineTable.vue?vue&type=script&lang=js"
import style0 from "./LineTable.vue?vue&type=style&index=0&id=2f825fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f825fa0",
  null
  
)

export default component.exports